import React from 'react'
import { colors } from '../../../styles/vars/colors.style'

const ExpeditionRouteCircle = ({
  width = 61,
  height = 61,
  stroke = colors.dark,
  rotation = 0,
  pathLength = 195,
  responsive = true,
  forwardRef = null,
}) => {
  const svgAttributes = responsive
    ? {}
    : {
        width,
        height,
      }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 61 61"
      focusable="false"
      role="img"
      fill="none"
      style={{ transform: `rotateZ(${rotation}deg)` }}
      {...svgAttributes}
    >
      <circle
        ref={forwardRef}
        cx="30.3711"
        cy="30.1064"
        r="29.5"
        strokeDashoffset={pathLength}
        strokeDasharray={pathLength}
        stroke={stroke}
      />
    </svg>
  )
}

export default ExpeditionRouteCircle
